module.exports = __webpack_public_path__ + "media/images/emblems/Visperterminen-coat_of_arms-e9b1eab8c28e37fec9d09957edbc1343.svg";